import React from 'react';
import { Paper, Typography, Grid, Box, Divider, Chip } from '@mui/material';

// Mapeamento dos valores dos conselhos
const councilLabels: Record<string, string> = {
    food_security: 'Conselho Municipal de Segurança Alimentar e Nutricional',
    solidarity_economy: 'Conselho Municipal de Economia Solidária',
    environment: 'Conselho Municipal de Meio Ambiente',
    other: 'Outro',
};

const InfoField: React.FC<{ label: string; value: React.ReactNode }> = ({ label, value }) => (
    <Box mb={1}>
        <Typography variant="subtitle1" fontWeight={600}>
            {label}
        </Typography>
        <Typography variant="body1">
            {value || 'Não informado'}
        </Typography>
    </Box>
);

const ChipsField: React.FC<{ label: string; values: string[]; other?: string }> = ({ label, values, other }) => (
    <Box mb={1}>
        <Typography variant="subtitle1" fontWeight={600}>
            {label}
        </Typography>
        {values && values.length > 0 ? (
            <Box sx={{ mt: 0.5 }}>
                {values.map((item, idx) => (
                    <Chip
                        key={idx}
                        label={councilLabels[item] || item}
                        sx={{ mr: 1, mb: 1 }}
                    />
                ))}
                {other && <Chip label={other} color="secondary" sx={{ mr: 1, mb: 1 }} />}
            </Box>
        ) : (
            <Typography variant="body1" color="text.secondary">
                Nenhum informado
            </Typography>
        )}
    </Box>
);

interface Step3CmdrsViewProps {
    data: {
        existingCouncils: string[];
        otherExistingCouncil: string;
        seatedCouncils: string[];
        otherSeatedCouncil: string;
        isConsortiumMember: boolean | null;
        participatesActivities: boolean | null;
        activitiesDescription: string;
        hasSusaf: boolean | null;
    };
}

const Step3CmdrsView: React.FC<Step3CmdrsViewProps> = ({ data }) => (
    <Paper elevation={1} sx={{ p: 3, mt: 2 }}>
        <Typography variant="h5" color="primary" gutterBottom>
            Conselhos e Participações
        </Typography>
        <Divider sx={{ mb: 3 }} />

        <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
                <ChipsField
                    label="Conselhos existentes no município"
                    values={data.existingCouncils}
                    other={data.otherExistingCouncil}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <ChipsField
                    label="Conselhos com assento no CMDRS"
                    values={data.seatedCouncils}
                    other={data.otherSeatedCouncil}
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <InfoField
                    label="O município integra consórcio público?"
                    value={
                        data.isConsortiumMember === null
                            ? 'Não informado'
                            : data.isConsortiumMember
                                ? 'Sim'
                                : 'Não'
                    }
                />
            </Grid>
            <Grid item xs={12} md={6}>
                <InfoField
                    label="Participa de atividades em rede?"
                    value={
                        data.participatesActivities === null
                            ? 'Não informado'
                            : data.participatesActivities
                                ? 'Sim'
                                : 'Não'
                    }
                />
            </Grid>
            {data.participatesActivities && (
                <Grid item xs={12}>
                    <InfoField
                        label="Descrição das atividades em rede"
                        value={data.activitiesDescription}
                    />
                </Grid>
            )}
            <Grid item xs={12} md={6}>
                <InfoField
                    label="Possui SUSAF?"
                    value={
                        data.hasSusaf === null
                            ? 'Não informado'
                            : data.hasSusaf
                                ? 'Sim'
                                : 'Não'
                    }
                />
            </Grid>
        </Grid>
    </Paper>
);

export default Step3CmdrsView;